import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Clock, ChefHat } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";

interface MealOption {
  name: string;
  description: string;
  recipe: {
    prepTime: number;
    cookTime: number;
  };
}

interface MealOptionsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  options: MealOption[];
  onSelect: (option: MealOption) => void;
  loading?: boolean;
}

export function MealOptionsDialog({
  isOpen,
  onClose,
  options = [],
  onSelect,
  loading = false,
}: MealOptionsDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>בחר ארוחה חדשה</DialogTitle>
        </DialogHeader>

        <ScrollArea className="h-[500px] pr-4">
          <div className="space-y-4">
            {loading ? (
              <div className="flex items-center justify-center h-40">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
              </div>
            ) : Array.isArray(options) && options.length > 0 ? (
              options.map((option, index) => (
                <Card
                  key={index}
                  className="p-4 hover:bg-accent transition-colors cursor-pointer"
                  onClick={() => onSelect(option)}
                >
                  <div className="space-y-3">
                    <div className="flex flex-row-reverse justify-between items-start">
                      <h3 className="text-lg font-medium">{option.name}</h3>
                      <div className="flex items-center gap-2 text-muted-foreground">
                        <span className="text-sm">
                          {option.recipe.prepTime + option.recipe.cookTime} דקות
                        </span>
                        <Clock className="h-4 w-4" />
                      </div>
                    </div>
                    <p className="text-sm text-muted-foreground text-right">
                      {option.description}
                    </p>
                    <div className="flex justify-start">
                      <Button
                        variant="ghost"
                        size="sm"
                        className="gap-2"
                        onClick={(e) => {
                          e.stopPropagation();
                          onSelect(option);
                        }}
                      >
                        בחר ארוחה זו
                        <ChefHat className="h-4 w-4 mr-2" />
                      </Button>
                    </div>
                  </div>
                </Card>
              ))
            ) : (
              <div className="text-center text-muted-foreground">
                לא נמצאו אפשרויות ארוחה
              </div>
            )}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
